/**
 * Created by hzy on 2019/7/9.
 */
/**
 * @style style
 * @className className
 * @onReSet 点击重置的回调
 * @onOk 点击确定的回调
 * @onChange onChange的回调
 * @dataSource 模板数据源
 * @tabIndex 默认tab位置
 * @title 标题
 * @id 储于localstorage的标识id
 */
import React, {useState, useEffect} from 'react';
import PropTypes, {oneOfType} from 'prop-types';
import {Button} from 'antd-mobile';
import {localStore} from 'mutants-microfx';
import FilterContent from './FilterContent';
import {dateFormat} from './utils';
import './style.less';

const dataSourceMock = [
  {
    title: '查看范围',
    type: '',
    key: 'searchType',
    // defaultValue: [{value: '1', label: '客户'}],
    content: [
      {value: '0', label: '全部'}, {value: '1', label: '客户'}, {value: '2', label: '单据日期'},
      {value: '3', label: '部门'}, {value: '4', label: '业务员'}, {value: '5', label: '联系人'},
      {value: '6', label: '收款到日期'}]
  }, {
    title: '日期范围',
    type: 'date',
    key: 'rangeType',
    content: [
      {value: '0', label: '全部'}, {value: '1', label: '今天'}, {value: '2', label: '昨天'},
      {value: '3', label: '本周'}, {value: '4', label: '本月'}, {value: '5', label: '上月'},
      {value: '6', label: '本季度'}, {value: '8', label: '本年'}
    ],
    // defaultValue: [{value: 'begin', label: '2019-07-11'}, {value: 'end', label: '2019-07-02'}],
    dateRange: [{value: 'begin', label: '2019-07-11'}, {value: 'end', label: '2019-07-02'}]
  }, {
    title: '选择日期',
    type: 'date',
    key: 'selectDateType',
    dateRange: [{value: 'selectDate', label: '2019-07-11'}]
  }
];


export default function FilterView(props) {
  const {title = '', tabIndex = 0, style = {}, onOk, onReSet, onChange, className = '',
    isTab, id = 'default', dataSource = []} = props;
  const [viewModel, setViewModel] = useState(JSON.parse(JSON.stringify(dataSource)) || []);
  useEffect(() => {

    const filterCacheData = localStore.get('filterCache') || {};
    const user = localStore.get('user') || {};

    const defaultValues = {};
    viewModel.forEach(v => {
      const {key, defaultValue} = v || {};
      if (defaultValue) {
        defaultValues[key] = defaultValue;
      }
    })

    const cacheValue = filterCacheData[id] || {};
    Object.keys(cacheValue).forEach(v => { // 过滤 localStore 中key为空数组项
      if (Array.isArray(cacheValue[v]) && !cacheValue[v].length) {
        delete cacheValue[v];
      }
    });
    const data = Object.assign(defaultValues, cacheValue); // 合并default 和 localStore中的数据，优先localStore

    if (Object.keys(data).length) {
      viewModel.forEach(v => {
        const {key, content = [], dateRange = [], defaultValue} = v || {};
        (data[key] || []).forEach(vv => {
          const {value, label} = vv || {};
          if (content.length) {
            const contentItem = content.find(item => item.value === value);
            contentItem && (contentItem.selected = true);
          }
          if (dateRange.length) {
            const dateItem = dateRange.find(item => item.value === value);
            dateItem && (dateItem.date = new Date(label));
          }
        });
      })
    }
  }, []);

  let dataModel = [];
  let tabIndexState = tabIndex;

  const dataOnChange = (data, index) => {
    dataModel = data;
    tabIndexState = index;
    onChange && onChange({dataModel, tabIndexState});
  };

  const submitData = () => {
    const submitValue = {};
    dataModel.forEach(value => {
      const {type, key, content = [], dateRange = []} = value;
      const selectValue = content.map(v => {
        const {selected, ...rest} = v || {};
        if (selected) {
          return rest;
        }
      }).filter(v => v);

      const dateValue = dateRange.map(v => {
        const {value, date} = v || {};
        if (date) {
          return {value, label: dateFormat(+date, 'yyyy-MM-dd')};
        }
      }).filter(v => v);

      const submitItem = selectValue.length ? selectValue : dateValue;

      submitValue[key] = submitItem;
    });
    return submitValue;
  };

  const resetData = () => {
    const resetValue  = (content = [], dateRange = []) => {
      content.forEach(v => {
        delete v.selected;
      });
      dateRange.forEach(v => {
        delete v.date;
      });
    }

    if (isTab) {
      const {content =[], dateRange = []} = dataModel[tabIndexState] || {};
      resetValue(content, dateRange);
    } else {
      dataModel.forEach(v => {
        const {content =[], dateRange = []} = v;
        resetValue(content, dateRange);
      });
    }

    setViewModel([...dataModel]);
  };

  const handleOk = () => {
    const data = submitData();
    const filterCacheData = localStore.get('filterCache') || {};
    filterCacheData[id] = data;
    localStore.set('filterCache', filterCacheData);
    onOk && onOk(data);
  };

  const handleReSet = () => {
    resetData();
    onReSet && onReSet();
  };

  return (
    <div className={`filter-container ${className}`} style={style}>
      {!!title && <h1>{title}</h1>}
      <FilterContent
        onChange={dataOnChange}
        viewModel={viewModel}
        isTab={isTab}
      />
      <div className='operator-box'>
        <Button onClick={handleReSet}>重置</Button>
        <Button onClick={handleOk} type='primary'>确定</Button>
      </div>
    </div>
  );
}

FilterView.propTypes = {
  onReSet: PropTypes.func,
  onOk: PropTypes.func,
  onChange: PropTypes.func,
  dataSource: PropTypes.array,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
};


